import { DataGridHead, DataGridHeader, DataGridRow } from '@twilio-paste/core/data-grid';

export function TargetsTableHeader() {
  return (
    <DataGridHead>
      <DataGridRow>
        <DataGridHeader>Target Name</DataGridHeader>
        <DataGridHeader>Target ID</DataGridHeader>
        <DataGridHeader>App Name</DataGridHeader>
        <DataGridHeader textAlign="center">Status</DataGridHeader>
        <DataGridHeader textAlign="center">Actions</DataGridHeader>
      </DataGridRow>
    </DataGridHead>
  );
}
